import * as Objdict from "objdict"
import stages from "@frog/source/data/stages.js"

import Tiled from "@frog/source/utility/Tiled.js"

let encounters = [
    {
        "slug": "level1",
        "type": "combat",
        // "audio": "Music:1",
        "label": "",
        "stage": {
            "world": Tiled.parse({
                "tilemap": require("@frog/source/data/encounters/1.json"),
                "tileset": require("@frog/source/assets/images/bomber-tactics/tiles/tileset.json"),
            }),
            "victory": {"condition": "annihilate"},
            "failure": {"condition": "annihilate"},
            "units": [
                // {"position": {"x": 7, "y": 6, "z": 1}, "reference": "red-bomber", "affiliation": "good"},
                // {"position": {"x": 11, "y": 6, "z": 1}, "reference": "bomber", "affiliation": "bad"},
            ],
            "events": {
                "success": [
                    {"type": "navigate", "path": "/game/encounters/level2"},
                ],
            },
        },
    },
    {
        "slug": "level2",
        "type": "combat",
        "label": "",
        "stage": {
            "world": Tiled.parse({
                "tilemap": require("@frog/source/data/encounters/2.json"),
                "tileset": require("@frog/source/assets/images/bomber-tactics/tiles/tileset.json"),
            }),
            "victory": {"condition": "annihilate"},
            "failure": {"condition": "annihilate"},
            "units": [
                // {"position": {"x": 7, "y": 6, "z": 1}, "reference": "red-bomber", "affiliation": "good"},
                // {"position": {"x": 11, "y": 6, "z": 1}, "reference": "bomber", "affiliation": "bad"},
            ],
            "events": {
                "success": [
                    {"type": "navigate", "path": "/game/encounters/level3"},
                ],
            },
        },
    },
    {
        "slug": "level3",
        "type": "combat",
        "audio": "Music:2",
        "label": "",
        "stage": {
            "world": Tiled.parse({
                "tilemap": require("@frog/source/data/encounters/3.json"),
                "tileset": require("@frog/source/assets/images/bomber-tactics/tiles/tileset.json"),
            }),
            "victory": {"condition": "annihilate"},
            "failure": {"condition": "annihilate"},
            "units": [
                // {"position": {"x": 7, "y": 6, "z": 1}, "reference": "red-bomber", "affiliation": "good"},
                // {"position": {"x": 11, "y": 6, "z": 1}, "reference": "bomber", "affiliation": "bad"},
            ],
            "events": {
                "success": [
                    {"type": "navigate", "path": "/game/encounters/level4"},
                ],
            },
        },
    },
    {
        "slug": "level4",
        "type": "combat",
        "label": "",
        "stage": {
            "world": Tiled.parse({
                "tilemap": require("@frog/source/data/encounters/4.json"),
                "tileset": require("@frog/source/assets/images/bomber-tactics/tiles/tileset.json"),
            }),
            "victory": {"condition": "annihilate"},
            "failure": {"condition": "annihilate"},
            "units": [
                // {"position": {"x": 7, "y": 6, "z": 1}, "reference": "red-bomber", "affiliation": "good"},
                // {"position": {"x": 11, "y": 6, "z": 1}, "reference": "bomber", "affiliation": "bad"},
            ],
            "events": {
                "success": [
                    {"type": "navigate", "path": "/game/encounters/level5"},
                ],
            },
        },
    },
    {
        "slug": "level5",
        "type": "combat",
        "audio": "Music:3",
        "label": "",
        "stage": {
            "world": Tiled.parse({
                "tilemap": require("@frog/source/data/encounters/6.json"),
                "tileset": require("@frog/source/assets/images/bomber-tactics/tiles/tileset.json"),
            }),
            "victory": {"condition": "annihilate"},
            "failure": {"condition": "annihilate"},
            "units": [
                // {"position": {"x": 7, "y": 6, "z": 1}, "reference": "red-bomber", "affiliation": "good"},
                // {"position": {"x": 11, "y": 6, "z": 1}, "reference": "bomber", "affiliation": "bad"},
            ],
            "events": {
                "success": [
                    {"type": "navigate", "path": "/game/encounters/level6"},
                ],
            },
        },
    },
    {
        "slug": "level6",
        "type": "combat",
        "label": "",
        "stage": {
            "world": Tiled.parse({
                "tilemap": require("@frog/source/data/encounters/5.json"),
                "tileset": require("@frog/source/assets/images/bomber-tactics/tiles/tileset.json"),
            }),
            "victory": {"condition": "annihilate"},
            "failure": {"condition": "annihilate"},
            "units": [
                // {"position": {"x": 7, "y": 6, "z": 1}, "reference": "red-bomber", "affiliation": "good"},
                // {"position": {"x": 11, "y": 6, "z": 1}, "reference": "bomber", "affiliation": "bad"},
            ],
            "events": {
                "success": [
                    {"type": "navigate", "path": "/credits"},
                ],
            },
        },
    },
]

encounters = Objdict.convert(encounters, "slug")
encounters = Objdict.map(encounters, (encounter) => {
    if(encounter.nextEncounterSlug != undefined) { // TODO: actually define this in the encounter.stage, not the encounter
        encounter.stage.events = encounter.stage.events || {}
        encounter.stage.events["success"] = [
            {
                "type": "load encounter",
                "isPreservingState": true,
                "encounterSlug": encounter.nextEncounterSlug,
            },
        ]
        encounter.stage.events["failure"] = [
            {
                "type": "load encounter",
                "isPreservingState": false,
                "encounterSlug": encounter.slug,
            }
        ]
        // if(encounter.nextEncounterSlug == "level4") { // TODO: what the fuck is this hardcoding overloading??
        //     encounter.stage.events["success"][0].duration = 4
        // }
        if(encounter.nextEncounterSlug == "credits") { // TODO: what the fuck is this hardcoding overloading??
            encounter.stage.events["success"] = [
                {
                    "type": "navigate",
                    "path": "/credits"
                },
            ]
        }
    }
    if(encounter.stage.reference != undefined) {
        if(stages[encounter.stage.reference] == undefined) {
            throw "Could not find stage " + encounter.stage.reference
        }
        encounter.stage = stages[encounter.stage.reference]
        // encounter.stage = Objdict.merge(referencedStage, encounter.stage)
        // TODO: Since this is a shallow merge, this isn't accomplishing anything.
        // TODO: there are now three formats, one is the text-friendly atomic file,
        // format, one is the in-data referenced format but not fully playable, and
        // the last is the in class fully playable. Maybe the interim one in-data
        // shouldn't exist and should remain lightweight and jsut be JIT'd when
        // instantiating everything else for the encounter? (which will have
        // it's own set of overrides)
    }
    return encounter
})

export default encounters
